import { initReactI18next } from "react-i18next";
import i18n from "i18next";

const resources = {
  en: {
    translation: {
      // Navigation and Common UI
      "Filter clientsheets...": "Filter clientsheets...",
      "Download Latest Clientsheet": "Download Latest Clientsheet",
      Reset: "Reset",
      "BCI-FILES": "BCI-FILES",
      "Downloading...": "Downloading...",
      "Download selected": "Download selected",
      "BCI - Client Portal": "BCI - Client Portal",
      "Toggle notifications": "Toggle notifications",
      "Toggle navigation menu": "Toggle navigation menu",
      "Toggle user menu": "Toggle user menu",
      Back: "Back",
      View: "View",
      "Toggle theme": "Toggle theme",
      Light: "Light",
      Dark: "Dark",
      System: "System",

      // Contact Support
      Subject: "Subject",
      "Brief description of your issue": "Brief description of your issue",
      "Please provide a brief subject for your message.": "Please provide a brief subject for your message.",
      Message: "Message",
      "Please describe your issue in detail...": "Please describe your issue in detail...",
      "Please provide detailed information about your issue or question.":
        "Please provide detailed information about your issue or question.",
      "Send Message": "Send Message",
      "Sending...": "Sending...",
      "Message sent successfully!": "Message sent successfully!",
      "We'll get back to you as soon as possible.": "We'll get back to you as soon as possible.",

      // Clientsheet Overview
      "Margin Amount": "Margin Amount",
      "Delivered Amount": "Delivered Amount",
      "Invoiced Amount": "Invoiced Amount",
      "Browse Archive": "Browse Archive",
      "Clientsheets Overview": "Clientsheets Overview",
      percentageChangeFromDate: "{{sign}}{{percentage}}% from {{date}}",

      // Invoice Table
      "Invoice type": "Invoice type",
      Year: "Year",
      Month: "Month",
      "Filter by filename...": "Filter by filename...",
      // Client Switcher
      "Switch Client": "Switch Client",
      "No client found.": "No client found.",
      "Selected Client": "Selected Client",
      "Available Clients": "Available Clients",
      "Search client...": "Search client...",

      // Account and Authentication
      Platform: "Platform",
      "Contact Support": "Contact Support",
      "My Account": "My Account",
      Settings: "Settings",
      "Select Language": "Select Language",
      "Language Settings": "Language Settings",
      Support: "Support",
      Logout: "Logout",
      "Welcome back": "Welcome back",
      "Enter your email to sign in to your account": "Enter your email to sign in to your account",
      Email: "Email",
      "john@example.com": "john@example.com",
      "A magic link, which allows you to log in securely without a password, will be sent to the email address you provide.":
        "A magic link, which allows you to log in securely without a password, will be sent to the email address you provide.",
      "Sign In with Email": "Sign In with Email",
      "We sent you a login link.": "We sent you a login link.",
      "If you don't see it, check your spam folder.": "If you don't see it, check your spam folder.",
      "Reset Password": "Reset Password",
      "Password reset successful": "Password reset successful",
      "Your password has been reset successfully": "Your password has been reset successfully",
      "Reset API Password": "Reset API Password",
      "Enter your new password below": "Enter your new password below",
      "Visit the OPENAPI documentation": "Visit the OPENAPI documentation",
      "API password reset successful": "API password reset successful",
      "Your API password has been reset successfully": "Your API password has been reset successfully",
      "API Access": "API Access",

      // Magic Link Verification
      "Verifying magic link...": "Verifying magic link...",
      "Sorry, this token was either expired or already used. Please try logging in again.":
        "Sorry, this token was either expired or already used. Please try logging in again.",
      "Verify Magic Link": "Verify Magic Link",
      "Verifying your magic link...": "Verifying your magic link...",
      "No magic link found. Please check your email for a valid link.":
        "No magic link found. Please check your email for a valid link.",

      // Main Navigation
      Clientsheet: "Clientsheet",
      Pricesheet: "Pricesheet",
      Invoices: "Invoices",
      Sparkspread: "Sparkspread",

      // Error Pages
      "404 Page Not Found": "404 Page Not Found",
      "Sorry, we couldn't find the page you're looking for.": "Sorry, we couldn't find the page you're looking for.",
      "403 Forbidden": "403 Forbidden",
      "Sorry, you are not allowed to access this resource. If you believe this is an error, please contact our support team to get access.":
        "Sorry, you are not allowed to access this resource. If you believe this is an error, please contact our support team to get access.",
      "Return to dashboard": "Return to dashboard",

      // Table Components
      "No results.": "No results.",
      "{{selected}} of {{total}} row(s) selected.": "{{selected}} of {{total}} row(s) selected.",
      "Rows per page": "Rows per page",
      "Page {{current}} of {{total}}": "Page {{current}} of {{total}}",
      "Go to first page": "Go to first page",
      "Go to previous page": "Go to previous page",
      "Go to next page": "Go to next page",
      "Go to last page": "Go to last page",
      "Toggle columns": "Toggle columns",
      Asc: "Ascending",
      Desc: "Descending",
      Hide: "Hide",
      Date: "Date",
      Download: "Download",
      "Select all": "Select all",
      "Select row": "Select row",

      // SparkSpread Components
      "Select futures contracts": "Select futures contracts",
      "Select a spread": "Select a spread",
      "Sparkspread Products": "Sparkspread Products",
      "Select contract types": "Select contract types",
      "Price History": "Price History",
      "Spread History": "Spread History",
      "Efficiency History": "Efficiency History",
      "Clean Spark Spread": "Clean Spark Spread",
      "Dark Spread": "Dark Spread",
      "Gas Price": "Gas Price",
      "Power Price": "Power Price",
      "Coal Price": "Coal Price",
      "CO2 Price": "CO2 Price",
      "Loading data...": "Loading data...",
      "Error loading data": "Error loading data",
      "No data available": "No data available",
      From: "From",
      To: "To",
      Apply: "Apply",
      "Reset filters": "Reset filters",
      "Download CSV": "Download CSV",
      "Chart view": "Chart view",
      "Table view": "Table view",

      // SparkSpread Dashboard
      "Supporting plot: TTF": "Supporting plot: TTF",
      "Supporting plot: Base NL": "Supporting plot: Base NL",
      "Supporting plot: Peak NL": "Supporting plot: Peak NL",
      "Please select a contract": "Please select a contract",
      "No data available for the selected spread and contracts":
        "No data available for the selected spread and contracts",

      // Pricesheet Components
      "Updated At": "Updated At",
      "Power Base": "Power Base",
      "Power Peak": "Power Peak",
      TTF: "TTF",
      "TTF Pricesheet": "TTF Pricesheet",
      "Power Base Pricesheet": "Power Base Pricesheet",
      "Power Peak Pricesheet": "Power Peak Pricesheet",
      "Filter periods...": "Filter periods...",
      Columns: "Columns",
      Period: "Period",
      Bid: "Bid",
      Offer: "Offer",
      Settle: "Settle",
      Delta: "Delta",
      "POWER BASELOAD": "POWER BASELOAD",
      "POWER PEAKLOAD": "POWER PEAKLOAD",
      "Pricing Data Stale": "Pricing Data Stale",
      "The pricing sheet has not changed for {{count}} consecutive updates. We are investigating the issue.":
        "The pricing sheet has not changed for {{count}} consecutive updates. We are investigating the issue.",

      // Client Credentials
      "Client Credentials - API Access": "Client Credentials - API Access",
      "Create Credential": "Create Credential",
      "Client ID and Client Secret": "Client ID and Client Secret",
      "used for API access in conjunction with your API password and registered email address. Each credential can be configured with specific permissions to ensure controlled and secure access to authorized resources.":
        "used for API access in conjunction with your API password and registered email address. Each credential can be configured with specific permissions to ensure controlled and secure access to authorized resources.",
      "API Documentation": "API Documentation",
      "Generate a new client credential with selected scopes. The Client ID and Client Secret will be displayed only once after creation. Use these credentials with the POST /api/v1/login/access-token endpoint to obtain an access token that grant secure, authorized access to the API.":
        "Generate a new client credential with selected scopes. The Client ID and Client Secret will be displayed only once after creation. Use these credentials with the POST /api/v1/login/access-token endpoint to obtain an access token that grant secure, authorized access to the API.",
      Permissions: "Permissions",
      "Create Client Credential": "Create Client Credential",
      "Failed to create client credential": "Failed to create client credential",
      "Delete Client Credential": "Delete Client Credential",
      "Are you sure you want to delete this client credential? This action cannot be undone.":
        "Are you sure you want to delete this client credential? This action cannot be undone.",
      "Deleting...": "Deleting...",
      Success: "Success",
      "Client credential deleted successfully": "Client credential deleted successfully",
      "Failed to delete client credential. Please try again later.":
        "Failed to delete client credential. Please try again later.",
      Cancel: "Cancel",
      Delete: "Delete",
      Error: "Error",
      "Back to API Access": "Back to API Access",

      // Client Credential Dialog
      "Save Your Client Credentials": "Save Your Client Credentials",
      "Please copy and store these credentials in a secure location. For security reasons, the client secret will not be displayed again after you close this dialog.":
        "Please copy and store these credentials in a secure location. For security reasons, the client secret will not be displayed again after you close this dialog.",
      "Client ID": "Client ID",
      "Client Secret": "Client Secret",
      Show: "Show",
      Copy: "Copy",
      Copied: "Copied",
      "Credentials copied to clipboard": "Credentials copied to clipboard",
      "I've saved the credentials": "I've saved the credentials",

      // Price Update
      "Save Preferences": "Save Preferences",
      "Saving...": "Saving...",
      "Price update preferences updated successfully": "Price update preferences updated successfully",
      "Price Update Preferences": "Price Update Preferences",
      "Emissions [EUR/ton]": "Emissions [EUR/ton]",
      "Gas [EUR/MWh]": "Gas [EUR/MWh]",
      "Electricity [EUR/MWh]": "Electricity [EUR/MWh]",
      "SparkSpread [EUR/MWh]": "SparkSpread [EUR/MWh]",
      "Price Update": "Price Update",
      Horizon: "Horizon",
      Long: "Long",
      Short: "Short",
      All: "All",
    },
  },
  nl: {
    translation: {
      // Navigation and Common UI
      "Filter clientsheets...": "Clientsheets filteren...",
      "Download Latest Clientsheet": "Laatste Clientsheet downloaden",
      Reset: "Herstellen",
      "BCI-FILES": "BCI-BESTANDEN",
      "Downloading...": "Bezig met downloaden...",
      "Download selected": "Selectie downloaden",
      "BCI - Client Portal": "BCI - Klantportaal",
      "Toggle notifications": "Meldingen aan/uit",
      "Toggle navigation menu": "Navigatiemenu aan/uit",
      "Toggle user menu": "Gebruikersmenu aan/uit",
      Back: "Terug",
      View: "Weergave",
      "Toggle theme": "Thema wijzigen",
      Light: "Licht",
      Dark: "Donker",
      System: "Systeem",

      // Contact Support
      Subject: "Onderwerp",
      "Brief description of your issue": "Korte beschrijving van uw probleem",
      "Please provide a brief subject for your message.": "Geef een kort onderwerp voor uw bericht.",
      Message: "Bericht",
      "Please describe your issue in detail...": "Geef een gedetailleerde beschrijving van uw probleem...",
      "Please provide detailed information about your issue or question.":
        "Geef gedetailleerde informatie over uw probleem of vraag.",
      "Send Message": "Bericht versturen",
      "Sending...": "Bericht verzenden...",
      "Message sent successfully!": "Bericht succesvol verzonden!",
      "We'll get back to you as soon as possible.": "We zullen zo snel mogelijk contact met u opnemen.",

      // Clientsheet Overview
      "Margin Amount": "Margin Bedrag",
      "Delivered Amount": "Geleverd Bedrag",
      "Invoiced Amount": "Gefactureerd Bedrag",
      "Browse Archive": "Blader in Archief",
      "Clientsheets Overview": "Clientsheets Overzicht",
      percentageChangeFromDate: "{{sign}}{{percentage}}% vanaf {{date}}",

      // Invoice Table
      "Invoice type": "Factuur type",
      Year: "Jaar",
      Month: "Maand",
      "Filter by filename...": "Filteren op bestandsnaam...",

      // Client Switcher
      "Switch Client": "Client wisselen",
      "No client found.": "Geen client gevonden.",
      "Selected Client": "Geselecteerde Client",
      "Available Clients": "Beschikbare Clients",
      "Search client...": "Client zoeken...",

      // Account and Authentication
      Platform: "Platform",
      "Contact Support": "Contact Ondersteuning",
      "My Account": "Mijn Account",
      Settings: "Instellingen",
      "Select Language": "Taal selecteren",
      "Language Settings": "Taalinstellingen",
      Support: "Ondersteuning",
      Logout: "Uitloggen",
      "Welcome back": "Welkom terug",
      "Enter your email to sign in to your account": "Voer je e-mailadres in om in te loggen",
      Email: "E-mail",
      "john@example.com": "john@voorbeeld.nl",
      "A magic link, which allows you to log in securely without a password, will be sent to the email address you provide.":
        "Er wordt een magic link verstuurd naar het opgegeven e-mailadres waarmee je veilig kunt inloggen zonder wachtwoord.",
      "Sign In with Email": "Inloggen met E-mail",
      "We sent you a login link.": "We hebben je een inloglink gestuurd.",
      "If you don't see it, check your spam folder.": "Als je de e-mail niet ziet, controleer dan je spammap.",
      "Reset Password": "Wachtwoord Resetten",
      "Reset API Password": "Reset API Wachtwoord",
      "Enter your new password below": "Voer je nieuwe wachtwoord in",
      "Password reset successful": "Wachtwoord succesvol gewijzigd",
      "Your password has been reset successfully": "Je wachtwoord is succesvol gewijzigd",
      "Visit the OPENAPI documentation": "Bekijk de OPENAPI documentatie",
      "API password reset successful": "API wachtwoord succesvol gewijzigd",
      "Your API password has been reset successfully": "Je API wachtwoord is succesvol gewijzigd",
      "API Access": "API Toegang",

      // Magic Link Verification
      "Verifying magic link...": "Magic link wordt geverifieerd...",
      "Sorry, this token was either expired or already used. Please try logging in again.":
        "Sorry, deze link is verlopen of al gebruikt. Probeer opnieuw in te loggen.",
      "Verify Magic Link": "Magic Link Verifiëren",
      "Verifying your magic link...": "Je magic link wordt geverifieerd...",
      "No magic link found. Please check your email for a valid link.":
        "Geen magic link gevonden. Controleer je e-mail voor een geldige link.",

      // Main Navigation
      Clientsheet: "Clientsheet",
      Pricesheet: "Prijsblad",
      Invoices: "Facturen",
      Sparkspread: "Sparkspread",

      // Error Pages
      "404 Page Not Found": "404 Pagina Niet Gevonden",
      "Sorry, we couldn't find the page you're looking for.": "Sorry, we kunnen de pagina die je zoekt niet vinden.",
      "403 Forbidden": "403 Geen Toegang",
      "Sorry, you are not allowed to access this resource. If you believe this is an error, please contact our support team to get access.":
        "Sorry, je hebt geen toegang tot deze pagina. Als je denkt dat dit een fout is, neem dan contact op met ons supportteam.",
      "Return to dashboard": "Terug naar dashboard",

      // Table Components
      "No results.": "Geen resultaten.",
      "{{selected}} of {{total}} row(s) selected.": "{{selected}} van {{total}} rij(en) geselecteerd.",
      "Rows per page": "Rijen per pagina",
      "Page {{current}} of {{total}}": "Pagina {{current}} van {{total}}",
      "Go to first page": "Ga naar eerste pagina",
      "Go to previous page": "Ga naar vorige pagina",
      "Go to next page": "Ga naar volgende pagina",
      "Go to last page": "Ga naar laatste pagina",
      "Toggle columns": "Kolommen aan/uit",
      Asc: "Oplopend",
      Desc: "Aflopend",
      Hide: "Verbergen",
      Date: "Datum",
      Download: "Downloaden",
      "Select all": "Alles selecteren",
      "Select row": "Rij selecteren",

      // SparkSpread Components
      "Select futures contracts": "Selecteer futures contracten",
      "Select a spread": "Selecteer een spread",
      "Sparkspread Products": "Sparkspread Producten",
      "Select contract types": "Selecteer contracttypes",
      "Price History": "Prijshistorie",
      "Spread History": "Spread Historie",
      "Efficiency History": "Efficiëntie Historie",
      "Clean Spark Spread": "Clean Spark Spread",
      "Dark Spread": "Dark Spread",
      "Gas Price": "Gasprijs",
      "Power Price": "Stroomprijs",
      "Coal Price": "Kolenprijs",
      "CO2 Price": "CO2-prijs",
      "Loading data...": "Gegevens laden...",
      "Error loading data": "Fout bij laden gegevens",
      "No data available": "Geen gegevens beschikbaar",
      From: "Van",
      To: "Tot",
      Apply: "Toepassen",
      "Reset filters": "Filters resetten",
      "Download CSV": "CSV downloaden",
      "Chart view": "Grafiekweergave",
      "Table view": "Tabelweergave",

      // SparkSpread Dashboard
      "Supporting plot: TTF": "Ondersteunende grafiek: TTF",
      "Supporting plot: Base NL": "Ondersteunende grafiek: Base NL",
      "Supporting plot: Peak NL": "Ondersteunende grafiek: Peak NL",
      "Please select a contract": "Selecteer een contract",
      "No data available for the selected spread and contracts":
        "Geen gegevens beschikbaar voor de geselecteerde spread en contracten",

      // Pricesheet Components
      "Updated At": "Bijgewerkt op",
      "Power Base": "Power Base",
      "Power Peak": "Power Peak",
      TTF: "TTF",
      "TTF Pricesheet": "TTF Prijslijst",
      "Power Base Pricesheet": "Power Base Prijslijst",
      "Power Peak Pricesheet": "Power Peak Prijslijst",
      "Filter periods...": "Filter periodes...",
      Columns: "Kolommen",
      Period: "Periode",
      Bid: "Bied",
      Offer: "Laat",
      Settle: "Settlement",
      Delta: "Delta",
      "POWER BASELOAD": "POWER BASELOAD",
      "POWER PEAKLOAD": "POWER PEAKLOAD",
      "Pricing Data Stale": "Prijsgegevens verouderd",
      "The pricing sheet has not changed for {{count}} consecutive updates. We are investigating the issue.":
        "Het prijsblad is al {{count}} opeenvolgende updates niet gewijzigd. We onderzoeken het probleem.",

      // Client Credentials
      "Client Credentials - API Access": "Client Credentials - API Toegang",
      "Create Credential": "Maak Credential",
      "Client ID and Client Secret": "Client ID en Client Secret",
      "used for API access in conjunction with your API password and registered email address. Each credential can be configured with specific permissions to ensure controlled and secure access to authorized resources.":
        "worden gebruikt voor API-toegang in combinatie met je API-wachtwoord en geregistreerd e-mailadres. Elke credential kan worden geconfigureerd met specifieke rechten om gecontroleerde en veilige toegang tot geautoriseerde bronnen te waarborgen.",
      "API Documentation": "API Documentatie",
      "Generate a new client credential with selected scopes. The Client ID and Client Secret will be displayed only once after creation. Use these credentials with the POST /api/v1/login/access-token endpoint to obtain an access token that grant secure, authorized access to the API.":
        "Genereer een nieuwe client credential met geselecteerde rechten. De Client ID en Client Secret worden slechts één keer getoond na aanmaak. Gebruik deze credentials met het POST /api/v1/login/access-token endpoint om een access token te verkrijgen voor veilige, geautoriseerde toegang tot de API.",
      Permissions: "Rechten",
      "Create Client Credential": "Maak Client Credential",
      "Failed to create client credential": "Maken van client credential mislukt",
      "Delete Client Credential": "Verwijder Client Credential",
      "Are you sure you want to delete this client credential? This action cannot be undone.":
        "Weet je zeker dat je deze client credential wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "Deleting...": "Verwijderen...",
      Success: "Succes",
      "Client credential deleted successfully": "Client credential succesvol verwijderd",
      "Failed to delete client credential. Please try again later.":
        "Verwijderen van client credential mislukt. Probeer het later opnieuw.",
      Cancel: "Annuleren",
      Delete: "Verwijderen",
      Error: "Fout",
      "Back to API Access": "Terug naar API Access",

      // Client Credential Dialog
      "Save Your Client Credentials": "Bewaar Je Client Credentials",
      "Please copy and store these credentials in a secure location. For security reasons, the client secret will not be displayed again after you close this dialog.":
        "Kopieer en bewaar deze credentials op een veilige plaats. Om veiligheidsredenen zal de client secret niet meer worden weergegeven nadat je dit venster sluit.",
      "Client ID": "Client ID",
      "Client Secret": "Client Secret",
      Show: "Tonen",
      Copy: "Kopiëren",
      Copied: "Gekopieerd",
      "Credentials copied to clipboard": "Credentials gekopieerd naar klembord",
      "I've saved the credentials": "Ik heb de credentials opgeslagen",

      // Price Update
      "Save Preferences": "Bewaar voorkeuren",
      "Saving...": "Bezig met opslaan...",
      "Price update preferences updated successfully": "Prijsupdatevoorkeuren succesvol bijgewerkt",
      "Price Update Preferences": "Prijsupdatevoorkeuren",
      "Emissions [EUR/ton]": "Emissierechten [EUR/ton]",
      "Gas [EUR/MWh]": "Gas [EUR/MWh]",
      "Electricity [EUR/MWh]": "Elektra [EUR/MWh]",
      "SparkSpread [EUR/MWh]": "SparkSpread [EUR/MWh]",
      "Price Update": "Prijsupdate",
      Horizon: "Horizon",
      Long: "Lang",
      Short: "Kort",
      All: "Alle",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") === "en" ? "en" : "nl",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
